import DataGrid from "../../components/DataTables/DataGrid/DataGrid.tsx";
import moment from "moment";

const CommissionsGrid = ({ commissions, isLoading }) => {
  console.log(commissions);
  const columns = [
    {
      name: "companyName",
      header: "ЗК",
      type: "string",
      minWidth: 250,
    },
    {
      name: "policyName",
      header: "Вид застраховка",
      type: "string",
    },
    {
      name: "selectedAgentOrOfficeValue",
      header: "Офис/Агент",
      type: "string",
    },
    {
      name: "percentage",
      header: "Комисион",
      type: "string",
    },
    {
      name: "isOtherPolicy",
      header: "Комисион - чужди",
      type: "string",
    },
    {
      name: "startDate",
      header: "Дата",
      type: "string",
    },
  ];

  console.log(commissions);
  return (
    <DataGrid
      columns={columns}
      dataSource={commissions}
      isLoading={isLoading}
      gridTitle={`Комисионни към ${moment().format("DD/MM/YYYY")}`}
      idProperty="commissions"
      csvFilename="commissions.csv"
      icon="fa-kit fa-regular-file-circle-question"
    />
  );
};

export default CommissionsGrid;
